import { UpdateResolver } from '@urql/exchange-graphcache';

import { inspectCache, updateCache } from '@/helper/urqlClient/cache/cacheHelpers';

import {
  MgsaForEditorDocument,
  MgsaForEditorQuery,
  MgsaForEditorQueryVariables,
} from '../../queries/generated/getMgsaForEditor';
import { UpdateMgsaMutation, UpdateMgsaMutationVariables } from '../generated/updateMgsa';
import { UpsertMgsaMutation, UpsertMgsaMutationVariables } from '../generated/upsertMgsa';

export function updateMgsaMutation(): UpdateResolver<
  UpdateMgsaMutation,
  UpdateMgsaMutationVariables
> {
  return (result, args, cache, info) => {
    const updatedMgsa = result?.updateMgsa?.mgsa;
    if (!updatedMgsa) {
      return;
    }
    inspectCache(cache, 'Query', 'mgsas', (field) => {
      if (!field.arguments) {
        return;
      }
      updateCache<MgsaForEditorQuery, MgsaForEditorQueryVariables>(
        cache,
        MgsaForEditorDocument,
        field.arguments,
        (queryData) => {
          queryData?.mgsas.edges?.forEach((itemEdge) => {
            if (itemEdge.node.id !== updatedMgsa.id) {
              return;
            }
            itemEdge.node = {
              ...itemEdge.node,
              ...updatedMgsa,
            };
          });
          return queryData;
        },
      );
    });
  };
}

export function upsertMgsaMutation(): UpdateResolver<
  UpsertMgsaMutation,
  UpsertMgsaMutationVariables
> {
  return (result, args, cache, info) => {
    const upsertedMgsa = result?.upsertMgsa?.mgsa;
    if (!upsertedMgsa) {
      return;
    }
    inspectCache(cache, 'Query', 'mgsas', (field) => {
      if (!field.arguments) {
        return;
      }
      const mgsasQueryInputVariables = field.arguments as MgsaForEditorQueryVariables;
      // Invalidate only the relevant mgsas queries.
      if (mgsasQueryInputVariables.filters?.entityIds?.includes(upsertedMgsa.entityId)) {
        cache.invalidate('Query', 'mgsas', field.arguments);
      }
    });
  };
}
